<template>
    <div class="d-flex" style="line-height: 2.2">
        <select :name="name" v-model="model_id" :id="name" class="chosen-select form-control">
            <option v-for="option in modelOptions" :value=option.id>{{ option.name }}</option>
        </select>
        <slot v-if="actionCopy"><a @click.prevent.stop="copyData()" class="ml-2 mr-1" href="">C</a> /</slot>
        <slot v-if="actionEdit"><a @click.prevent.stop="editData()" class="ml-1 mr-1" href="">E</a> /</slot>
        <slot v-if="actionDelete"><a @click.prevent.stop="deleteData()" class="ml-1" href="">X</a></slot>
        <div class="modal fade" id="modalData" tabindex="-1" role="dialog" aria-labelledby="data" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">{{ action.toUpperCase() }}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <input :disabled="action==='delete'" class="form-control" v-model="item.name">
                    </div>
                    <div class="modal-footer">

                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
                        <button v-if="action==='add'" @click="execute" type="button" class="btn btn-primary">Add
                        </button>
                        <button v-if="action==='edit'" @click="execute" type="button" class="btn btn-primary">Edit
                        </button>
                        <button v-if="action==='delete'" @click="execute" type="button" class="btn btn-primary">Delete
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';

export default {
    name: "SelectSimpleComponent",
    props: {
        initialValue: {
            default: null
        },
        table: {
            required: true
        },
        fieldName: {
            required: true
        },
        name: {
            required: true
        },
        fieldId: {
            required: true
        },
        actionCopy: {
            default: true
        },
        actionEdit: {
            default: true
        },
        actionDelete: {
            default: true
        },

    },
    data() {
        return {
            modelOptions: [],
            model_id: null,
            item: {
                id: null,
                name: ''
            },
            action: ''
        }
    },
    computed: {},

    methods: {
        seachItem() {
            let search = this.modelOptions.filter((e) => e.id.toString() === this.model_id.toString())
            return search.length > 0 ? JSON.parse(JSON.stringify(search[0])) : {}
        },
        getData() {
            let app = this;

            this.$loading(true);
            axios.post('/panel/get-data', {
                'table': this.table,
                name: this.fieldName,
                id: this.fieldId,
            })
                .then((response) => {
                    this.modelOptions = response.data;
                    app.$forceUpdate();
                })
                .catch(error => {
                    let message = '';
                    if (_.has(error, 'response.data.friendly_message')) {

                        message = error.response.status + ' - ' + error.response.data.friendly_message;

                    } else if (_.has(error, 'response.status')) {

                        message = 'Request failed with status code ' + error.response.status;

                    } else {

                        message = 'Application failed with error: ' + error.message;
                        console.log(error);
                    }

                    showMessage('w', message);

                })
                .then(() => {
                    this.$loading(false);
                });
        },
        async copyData() {
            this.item = this.seachItem()
            this.item.id = null;
            this.action = 'add';
            $('#modalData').modal('show')
        },
        editData() {
            this.item = this.seachItem()
            this.action = 'edit';
            $('#modalData').modal('show')
        },
        deleteData() {
            this.item = this.seachItem()
            this.action = 'delete'
            $('#modalData').modal('show')
        },
        async execute() {
            this.$loading(true);
            let app = this;
            await axios.post(`/panel/${this.action}-data`, {
                'table': this.table,
                name: this.fieldName,
                id: this.fieldId,
                value_name: this.item.name,
                value_id: this.item.id,
            })
                .then((response) => {
                    app.getData()
                    if (app.action === 'add') {
                        app.model_id = response.data[0]
                    }
                    app.$forceUpdate();
                    $('#modalData').modal('hide')
                })
                .catch(error => {
                    let message = '';
                    if (_.has(error, 'response.data.friendly_message')) {

                        message = error.response.status + ' - ' + error.response.data.friendly_message;

                    } else if (_.has(error, 'response.status')) {

                        message = 'Request failed with status code ' + error.response.status;

                    } else {

                        message = 'Application failed with error: ' + error.message;
                        console.log(error);
                    }

                    showMessage('w', message);

                })
                .finally(() => {
                    this.$loading(false);
                });
        }

    },
    mounted() {
        this.getData()
        this.model_id = this.initialValue
    },
}
</script>

<style>
.vs__selected {
    font-size: .8571em;
}

:root {
    /* Blue */
    --blue: #3f9ce8 !important;
    --blue-light: #C8E2F8;
    --blue-medium: #9ACBF3;
    --blue-dark: #125A96;
}

/* --== Scrollbar ==-- */

::-webkit-scrollbar {
    width: 5px;
    height: 5px;
}

::-webkit-scrollbar-thumb {
    background: var(--blue-medium);
    border-radius: 30px;
}

::-webkit-scrollbar-thumb:hover {
    background: var(--blue-dark);
}

::-webkit-scrollbar-track {
    background: white;
    border-radius: 0px;
}

</style>
